import React from 'react';
import LoginForm from '../Components/Signin';
import Copyright from '../Components/Copyrights/Copyright';
import Topbar from '../Components/Topbar/Topbar';
import MiddleBar from '../Components/MiddleBar/MiddleBar';
import Navbar from '../Components/Navbar/nav';
import Footer from '../Components/Footer/Footer';
import Newsletter from '../Components/NewsLetter/Newletter';
// import Breadcrumbs from '../Components/banner/New-banner';

const Login = () =>{
    return(
        <div>
        <div>
        <Topbar/>
        <MiddleBar/>
        <Navbar/>
        {/* <Breadcrumbs/> */}
        </div>
        <LoginForm/>
        
        <div>
        <Newsletter/>
        <Footer/>
        <Copyright/>    
        
        </div>
        </div>
    );
}
export default Login;